/*=========================================================================================
  File Name: mutations.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: etakeaway.OrderManager
  Author: Tan Tran
==========================================================================================*/

import authStorage from '../../../storage/authStorage'

export default {

    SET_LOGIN_STATE (state, payload) {

      state.auth.token = payload.token;
      state.auth.restaurantId = payload.restaurantId;
      state.auth.restaurantName = payload.restaurantName;
      state.auth.userName = payload.userName;
      state.auth.expiration = payload.expiration;
      state.auth.isLogin = payload.success;
      state.auth.message = payload.message;
      state.auth.expiredDate = payload.expiredDate;

    },

    SET_LOGOUT_STATE (state, payload) {

        state.auth.token = null;
        state.auth.restaurantManagerId = null;
        state.auth.restaurantName = null;
        state.auth.userName = null;
        state.auth.expiration = 0;
        state.auth.isLogin = false;
        state.auth.message = null;
        state.auth.expiredDate = null;
        authStorage.clearAuth();
        
    }
  }